export function initAttributionTracker() {
  try {
    const urlParams = new URLSearchParams(window.location.search);
    
    // 1. Check for UTM or source query parameters
    const utmSource = urlParams.get('utm_source');
    const sourceParam = urlParams.get('source') || urlParams.get('ref');
    
    let detectedSource = null;

    if (utmSource) {
      detectedSource = utmSource.toLowerCase();
    } else if (sourceParam && sourceParam.length < 30) {
      // Don't treat long uuid codes as sources (referral codes are processed separately)
      const isUuid = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(sourceParam);
      if (!isUuid) {
        detectedSource = sourceParam.toLowerCase();
      }
    }

    // 2. Parse HTTP Referrer if no query parameters exist
    if (!detectedSource && document.referrer) {
      const referrer = document.referrer.toLowerCase();
      try {
        const hostname = new URL(referrer).hostname;
        if (hostname.includes('facebook.com') || hostname.includes('fb.me') || hostname.includes('m.facebook.com')) {
          detectedSource = 'facebook';
        } else if (hostname.includes('instagram.com') || hostname.includes('ig.me')) {
          detectedSource = 'instagram';
        } else if (hostname.includes('twitter.com') || hostname.includes('t.co') || hostname.includes('x.com')) {
          detectedSource = 'twitter';
        } else if (hostname.includes('linkedin.com')) {
          detectedSource = 'linkedin';
        } else if (hostname.includes('youtube.com') || hostname.includes('youtu.be')) {
          detectedSource = 'youtube';
        } else if (hostname.includes('pinterest.com')) {
          detectedSource = 'pinterest';
        } else if (hostname.includes('tiktok.com')) {
          detectedSource = 'tiktok';
        } else if (hostname.includes('google.com')) {
          detectedSource = 'google-organic';
        } else if (hostname.includes('bing.com')) {
          detectedSource = 'bing-organic';
        } else if (hostname.includes('yahoo.com')) {
          detectedSource = 'yahoo-organic';
        } else if (!hostname.includes(window.location.hostname)) {
          // General external referrer
          detectedSource = hostname;
        }
      } catch (_) {}
    }

    // 3. Save the source if detected (do not overwrite if already set, to preserve initial click attribution)
    if (detectedSource) {
      const existing = localStorage.getItem('pd_lead_source');
      if (!existing) {
        localStorage.setItem('pd_lead_source', detectedSource);
        console.log(`[Attribution] Saved lead source: ${detectedSource}`);
      }
    }
  } catch (err) {
    console.error('[Attribution] Tracker error:', err);
  }
}

export function getAttributionSource() {
  return localStorage.getItem('pd_lead_source') || 'organic';
}
